import React, { useEffect, useState } from 'react';
import { Breadcrumb } from '../types';
import { Helmet } from 'react-helmet';

type BreadCrumbsProps = {
  breadcrumb: Breadcrumb[];
  templateName?: string;
  visible?: boolean;
  customClass?: string;
  noLeftPadding?: boolean;
};

export default function BreadCrumbs({
  breadcrumb,
  templateName,
  visible = true,
  customClass = 'railSeoWrap__brdCrumb',
  noLeftPadding
}: BreadCrumbsProps) {
  if (templateName !== undefined) {
    breadcrumb[breadcrumb.length - 1].displayString = templateName;
  }
  const [customClassFinal, setCustomClassFinal] = useState(customClass);
  useEffect(() => {
    if (noLeftPadding) {
      setCustomClassFinal(`${customClass} paddingLeftZero`);
    }
  }, [noLeftPadding]);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {`
          {
          "@context": "http://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": ${JSON.stringify(
            breadcrumb.map((b, idx) => ({
              '@type': 'ListItem',
              position: String(idx + 1),
              item: {
                '@type': 'WebPage',
                '@id': b.redirectionUrl || '',
                name: b.displayString
              }
            }))
          )}
          }
        `}
        </script>
        <script type="application/ld+json">
          {`{"@context":"http://schema.org/",
            "@type":"MobileApplication",
            "name":"MakeMyTrip",
            "aggregateRating":{"@type":"AggregateRating","ratingValue":"4.6","reviewCount":"1960035"},
            "applicationCategory":"Travel",
            "URL": "https://app.mmyt.co/Xm2V/appinstalltrainslanding",
            "operatingSystem":"Android, iOS"}`}
        </script>
      </Helmet>
      {visible && (
        <ul className={customClassFinal}>
          {breadcrumb.map((c, idx) =>
            breadcrumb.length !== idx + 1 ? (
              <li key={c.redirectionUrl}>
                <a href={c.redirectionUrl}>
                  <span itemProp="name">{c.displayString}</span>
                </a>
                &nbsp;&gt;&nbsp;
              </li>
            ) : (
              <li key="current">
                <span className="crntNode" itemProp="name">
                  {c.displayString}
                </span>
              </li>
            )
          )}
        </ul>
      )}
    </>
  );
}
